/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {
  sliderValue: string = "";
  @Input() isCreateSearch: boolean = false;
  @Input() isFilterSearch: boolean = false;
  @Input() isGenerateReport: boolean = false; 
  @Input() isAddUsers: boolean = false;
  @Input() isAddLine: boolean = false;
  @Input() sliderTitle: string = '';
  @Input() sliderTitleDescription: string = '';
  @Output() isClose: EventEmitter<boolean> = new EventEmitter();
  @Input() isLargeSlider: boolean = false;
  constructor() { 
    this.isClose.emit(false);

  }

  ngOnInit() {
    
  }
  closeSlider(): void{
   
    this.isClose.emit(true);
  }
  
}
